module.exports = __webpack_public_path__ + "e9aa9b10d9372be1086278017c3663ec.png";